import { render, staticRenderFns } from "./previous_marital_status.vue?vue&type=template&id=77f2347a&"
import script from "./previous_marital_status.vue?vue&type=script&lang=js&"
export * from "./previous_marital_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports